import React from 'react'

const Preloader = () => {
  return (
    <div className='preloader'>
        <div className="preloader-circle"></div>
    </div>
  )
}

export default Preloader